import { connect } from 'react-redux';
import Guide from '../../components/handoff/Guide';
import * as measurementUnits from '../../constants/measurementUnits';
import { arePercentageBasedGuidelinesEnabled, getZoomScale, } from '../../selectors/handoff';
function mapStateToProps(state, ownProps) {
    var percentageBasedGuidelinesEnabled = arePercentageBasedGuidelinesEnabled(state);
    return {
        zoomScale: getZoomScale(state),
        unit: percentageBasedGuidelinesEnabled ? measurementUnits.PERCENTAGE : null,
        value: percentageBasedGuidelinesEnabled
            ? ownProps.pctValue
            : ownProps.value,
    };
}
export default connect(mapStateToProps, null)(Guide);
